export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";